import { TranslationObject } from '../../i18n/translation';

const namespace = 'button';

const translations: TranslationObject = {
  close: {
    id: `${namespace}.close`,
    nb: 'Lukk',
    en: 'Close',
  },
  clear: {
    id: `${namespace}.clear`,
    nb: 'Tøm',
    en: 'Empty',
  },
  remove: {
    id: `${namespace}.remove`,
    nb: 'Fjern',
    en: 'Remove',
  },
};

export default translations;
